// extracted by mini-css-extract-plugin
export var card = "gP8dT";
export var main = "liN4j";